import { link } from "fs";

/* SPECIAL SYMBOLS:
    | : NEW LINE
    * : BOLD TEXT */

const InstructionsData = {
    coverDetails: {
        title: `‫צלחת מנצחת - משחק בריאות לסופר ילדים‬`,
        subTitle: `משחק קלפים משעשע בנושא תזונה מאוזנת ומגוונת‬`,
        creatorName: `משחק מאת: רועי חיגשי`,
        creatorDescription: `‫M.ed בחינוך לבריאות, מקדם בריאות בהומור‬‬`
    },
    generalInformation: [
        {
            title: `כמות משתתפים:`,
            content: `2-4 משתתפים`
        },
        {
            title: `למי המשחק מתאים?`,
            content: `למה להגביל? לכל מי שקולט את העניין:) אבל אם אתם מתעקשים אז מגיל 4 ומעלה`
        },
        {
            title: `מטרת המשחק:`,
            content: `*להגיע לצלחת מנצחת!* להשיג 6 קלפים המייצגים את 6 אבות המזון: פחמימות (קלף בצבע חום), חלבון (קלף בצבע לבן), שומן (קלף בצבע צהוב), ירק (קלף בצבע ירוק) ,פרי (קלף בצבע אדום) ומים (קלף בצבע כחול). ולהבין היכן ניתן להשיג את אבות המזון במאכלים הללו. |*וגם - לצבור נקודות על ידי השתתפות במשחקים רבים וצבירת ניצחונות.*`
        },
        {
            title: `הרעיון שמאחורי המשחק:`,
            content: `לבחור בתזונה מאוזנת יותר באמצעות הומור ומשחק.`
        },
        {
            title: `מהלך המשחק:`,
            content: `כל משתתף מקבל 6 קלפים|
            |בכל תור הוא צריך ראשית, להרים קלף מהקופה או מערימת הקלפים המשומשים ולזרוק קלף שאינו צריך.|
            |עליו לשמור כל פעם על 6 קלפים.|
            |לכל מהלך יש עד 30 שניות, אחרת המחשב יבצע מהלך אקראי.|
            |במידה ואחד השחקנים מותקף, עליו להגיב בקלף הנכון, ולא- עליו לספוג את ההתקפה.|
            |ניתן להתקיף את החבר הבא בתור באמצעות התקפות: "התקפת יומולדת", "התקפת טיול", "התקפת סבתא", "התקפת וירוס", "הקפא אוכל".|
            |התקפת "החלף קלף עם חבר" ו"החלף קלף לחבר" ניתנים להתקפה על כל שחקן במשחק ללא קשר לסדר!|
            |*חשוב:* "סופר קלף" יכול לשמש כל קלף מ-6 אבות המזון.|
            |*לניצחון:* יש לייצר רצף של "צלחת מנצחת" (ירק, פרי, מים, חלבון, פחמימה ושומן בריא). 
            משחק מסתיים כאשר אחד מהשחקנים השיג צלחת מנצחת!|
            `
        }],
    contactDetails: {
        title: `צור קשר:`,
        content: [{
            title: `שם:`,
            content: `רועי חיגשי`,
            isLink: false
        },
        {
            title: `e-mail:`,
            content: `royihigashi@gmail.com`,
            isLink: true
        }, {
            title: `אתר אינטרנט:`,
            content: `https://royiki.co.il/`,
            isLink: true
        }, {
            title: `פייסבוק:`,
            content: `https://www.facebook.com/royi.higashi`,
            isLink: true
        }, {
            title: `דף עיסקי:`,
            content: `רועיקי מצחיקי`,
            isLink: false
        }, {
            title: `ערוץ יוטיוב:`,
            content: `royihigashi`,
            isLink: false
        }]
    },
    aboutTheGame: {
        title: `על המשחק:`,
        content: `|*משחק הקלפים "צלחת מנצחת" הומצא במטרה לגרום לילדים לאכול בריא יותר ולהעלות את המודעות לתזונה עשירה ומגוונת יותר.*|
        ממציא המשחק, רועי חיגשי הידוע בכינויו "רועיקי מצחיקי", בעל תואר ראשון בחינוך גופני, ותואר שני (מאסטר|)  M.ED בחינוך לבריאות משלב רבות את מרכיב ההומור כמקדם למידה בחינוך.| 
        יום אחד ישב וחשב רועיקי, כיצד יוכל לגרום לילדים לאכול בריא יותר באמצעות משחק ואז עלה במוחו רעיון על משחק קלפים שבו יצטרכו הילדים להשיג גיוון באוכל בשביל לנצח. בשלב מסויים הבין רועיקי כי בחיים עצמם יש לא מעט מלכודות בדרך לאורח חיים בריא ולמה לא להביא את זה למשחק? לכן המציא את קלפי ההתקפה המשעשעים "התקפת סבתא" שמדמה את הגעתה של סבתא לביקור שבו היא "מפנקת" את נכדיה בממתקים, "התקפת יומולדת" המדמה הגעה ליומולדת שבו הילדים זוללים ממתקים ללא הבחנה, והתקפת "טיול שנתי" שבה מגיעים הילדים מצויידים היטב בממתקים וחטיפים גם לטיול הכי קצר. אבל אל חשש, יש קלפי הגנה להתקפות הללו... וכמובן עוד קלפים מפתיעים ומדליקים.`
    },
    actionCards: {
        title: `המיוחדים שלנו-קלפי עניין:`,
        content: [
            {
                cardTypeName: `"פיספסת"`,
                amount: 36,
                description: `להטעיה ולאסטרטגיה. בכל צבע יהיו 6 קלפי דמה. ברגע שהשחקנים רואים את הקלף הפוך הם מסיקים כי הקלף הוא מאכל...`,
                imgName: `demo2`
            },
            {
                cardTypeName: `"התקפת וירוס"`,
                amount: 3,
                description: `כאשר אני מותקף ואין לי קלף הגנה "שום+בצל" (המחזקים את המערכת החיסונית), יש לזרוק את כל הקלפים ולקחת  6 קלפים חדשים מהקופה. משמש כהתקפה לחבר הבא בתור.`,
                imgName: `virus2`
            },
            {
                cardTypeName: `"ברוקולי+כרובית"`,
                amount: 6,
                description: `קלף הגנה מפני התקפות "סבתא", "טיול" ו"יומולדת" (צריך להוריד אותו כתגובה להתקפה). משמש כמובן גם כירק .  (שווה 20 נקודות בניגוד לשאר קלפי המאכל והשתייה ששווים 10 נקודות)`,
                imgName: `cabbage-broccoli`
            },
            {
                cardTypeName: `"שום+בצל"`,
                amount: 6,
                description: `הגנה מפני התקפת וירוס (צריך להוריד אותו כתגובה להתקפה). משמש כמובן גם כירק  (שווה 20 נקודות בניגוד לשאר קלפי המאכל והשתייה ששווים 10 נקודות)`,
                imgName: `onion-garlic`
            },
            {
                cardTypeName: `"החלף קלף לחבר"`,
                amount: 3,
                description: `החלפה כפויה מהקופה לשחקן אחר,זהו קלף שיבוש מהלך. ניתן להשתמש בו כנגד כל חבר בשולחן ללא קשר לסדר המשחק. לאחר הורדת הקלף לערימת המשומשים, יש לבחור קלף של חבר ואז ללחוץ על הקופה וכך מוחלף לחבר הקלף.`,
                imgName: `switch-stack3`
            },
            {
                cardTypeName: `"החלף קלף עם חבר"`,
                amount: 3,
                description: `קלף מתנה וקלף התקפה לחבר בו זמנית. לאחר הורדת הקלף לערימת המשומשים, יש לבחור קלף מיוזם המהלך ואז לבחור בקלף של חבר וכך מתבצעת החלפה. ניתן להשתמש בו כנגד כל חבר בשולחן ללא קשר לסדר המשחק.`,
                imgName: `switch-friend2`
            },
            {
                cardTypeName: `"אוכל קפוא" (עצור תור)`,
                amount: 3,
                description: `קלף התקפה. חבר שהותקף עם קלף זה, פוסחים עליו תור אחד והוא חוזר לשחק בסיבוב הבא- ניתן להשתמש בו רק לשחקן הבא בתור.`,
                imgName: `stop1`
            },
            {
                cardTypeName: `"התקפת יומולדת"`,
                amount: 3,
                description: `לאחר הורדת הקלף לחבר הבא בתור, אם אין לחבר קלף הגנה ייעודי ("ברוקולי+כרובית") עליו לקחת  2 קלפים מקופת הממתקים. ניתן להשתמש בו רק לשחקן הבא בתור.`,
                imgName: `birthday1`
            },
            {
                cardTypeName: `"התקפת סבתא"`,
                amount: 3,
                description: `לאחר הורדת הקלף לחבר הבא בתור, אם אין לחבר קלף הגנה ייעודי ("ברוקולי+כרובית") עליו לקחת 2 קלפים מקופת הממתקים. ניתן להשתמש בו רק לשחקן הבא בתור.`,
                imgName: `grandma2`
            },
            {
                cardTypeName: `"התקפת טיול שנתי"`,
                amount: 3,
                description: `לאחר הורדת הקלף לחבר הבא בתור, אם אין לחבר קלף הגנה ייעודי ("ברוקולי+כרובית") עליו לקחת  2 קלפים מקופת הממתקים. ניתן להשתמש בו רק לשחקן הבא בתור.`,
                imgName: `trip2`
            },
            {
                cardTypeName: `"ארוחה בהפתעה"`,
                amount: 3,
                description: `קלף מתנה. בהורדת קלף זה, יש לקחת 2 קלפים מהקופה, ולזרוק 2 אחרים.`,
                imgName: `surprise-meal1`
            },
            {
                cardTypeName: `"קלף סופר" (ג'וקר)`,
                amount: 3,
                description: `קלף מתנה. קלף שיכול לשמש כל אחד מ6 אבות המזון.`,
                imgName: `joker1`
            }
        ]
    },
    foodCards: [
        {
            cardTypeName: `ירקות`,
            backgroundColor: `green`,
            foods: [
                {
                    name: `מלפפון`,
                    description: `נלחם במחלות. מרענן, מלא בנוזלים, שומר עלינו צעירים.`,
                    imgName: `cucumber`
                },
                {
                    name: `עגבניה`,
                    description: `נלחם במחלות קשות, עשיר בויטמין  C המחזק את מערכת החיסון. עשיר בוויטמין A
                    הטוב לעיניים, לעור, לעצמות ולשיניים. תורם לבריאות הלב תודות לויטמין B ואשלגן`,
                    imgName: `tomato`
                },
                {
                    name: `גזר`,
                    description: `עשיר בויטמין A המחזק את שרירי העיניים, וחשוב מאד לגדילה תקינה!
                    שומר עלינו צעירים, נלחם במחלות, משפר את בריאות הפה.`,
                    imgName: `carrot`
                },
                {
                    name: `גמבה`,
                    description: `מלכת הויטמין C!
                    עשירה בויטמין C המחזק את מערכת החיסון ושומרת עלינו צעירים, נלחמת במחלות, עשירה בויטמין E השומר על עור צעיר ושיער בריא. תורמת גם לבריאות העיניים ואף לשיפור מצב הרוח (ויטמין B6)`,
                    imgName: `pepper`
                },
                {
                    name: `ברוקולי`,
                    description: `נלחם במחלות, בדלקות ובאלרגיות, עשיר בסידן ובויטמין K, המחזקים את העצמות והשיניים, עשיר בברזל -המחזק את מערכת החיסון וחשוב לגדילה!
                    מנקה רעלים בגוף.`,
                    imgName: `cabbage-broccoli`
                },
                {
                    name: `כרובית`,
                    description: `עשירה ב"כולין" התורם להתפתחות המח ,עוזר בשמירה על המוח במצב בריא ותפקוד תקין. נלחמת במחלות ובדלקות, שומרת על בריאות הלב, ועשירה בסידן ובויטמין K, המחזק את עצמות הגוף והשיניים. מנקה רעלים בגוף, מסייעת בעיכול`,
                    imgName: `cabbage-broccoli`
                },
                {
                    name: `בצל`,
                    description: `מונע מחלות, שומר על רמת סוכר תקינה בדם, שומר על שיער בריא, מחזק מערכת החיסון, מחזק עצמות, מטפל באסטמה, נלחם בדלקות`,
                    imgName: `onion-garlic`
                },
                {
                    name: `שום`,
                    description: `נלחם במחלות, מאזן רמת סוכר בדם, נלחם בדלקות ובזיהומים, שומר על שיער בריא, משמש כאנטיביוטיקה טבעית,  משפר  ביצועים ספורטיביים, שומר על עצמות בריאות`,
                    imgName: `onion-garlic`
                }
            ]
        },
        {
            cardTypeName: `פירות`,
            backgroundColor: `red`,
            foods: [
                {
                    name: `תפוח`,
                    description: `שומר עלינו צעירים, נלחם במחלות. מועיל בתהליכי העיכול, מאזן סוכר בגוף.`,
                    imgName: `apple`
                },
                {
                    name: `אגס`,
                    description: `שומר על הסידן בגופינו, מחזק את המערכת החיסונית, עשיר בויטמין C הנלחם במחלות, מסייע בעיכול, נוגד חימצון, ועשיר בסיבים`,
                    imgName: `pear`
                },
                {
                    name: `שזיף`,
                    description: `מסייע בעיכול, עשיר בויטמין סי לחיזוק המערכת החיסונית, נלחם במחלות, נלחם בעייפות, מסייעים בחיזוק העצמות, מסייע לפעילות השרירית (עשיר באשלגן), שומר עלינו צעירים.`,
                    imgName: `plum`
                },
                {
                    name: `תפוז/קלמנטינה`,
                    description: `שומר עלינו צעירים, , עשיר בויטמין C השומר על העור, נלחם במחלות, ואף מחזק את המערכת החיסונית, שומר על פעילות לב תקינה. עשיר בויטמין A המשפר את הראייה.`,
                    imgName: `clementine`
                },
                {
                    name: `אפרסק`,
                    description: `שומר על עור בריא (עשיר בוויטמין A, ו-C), נלחם במחלות,מגן על בריאות הלב,  שומר על הראייה, נלחם בדלקות,עשיר בברזל המונע עייפות ומחזק את מערכת הדם. עשיר בפלואוראיד המחזק את השיניים והעצמות.`,
                    imgName: `peach`
                },
                {
                    name: `בננה`,
                    description: `מסדירה את פעילות המעיים, מלאה באנרגיה, עשיר באשלגן החיוני לבריאות הלב ועל בריאות העצם, מקור טוב למגנזיום החשוב לתפקוד תקין לשרירים. נלחם במחלות,  עשירה בברזל הנלחם בעייפות, עשיר בוויטמין A התורם לבריאות העיניים, ומעלה מצב רוח!`,
                    imgName: `banana`
                }
            ]
        },
        {
            cardTypeName: `שומנים בריאים`,
            backgroundColor: `yellow`,
            foods: [
                {
                    name: `אבוקדו`,
                    description: `שומר על עור צעיר מסייע בשמירה על בריאות המח, שומר על בריאות הלב, עשיר באשלגן החיוני לבריאות הלב ועל בריאות העצם, שומר עלינו צעירים ועל בריאות העיניים. נלחם במחלות רבות.`,
                    imgName: `avocado`
                },
                {
                    name: `טחינה גולמית (מלאה)`,
                    description: `משפרת תהליך עיכול, עשיר בחלבון, ובוויטמינים, בסידן ובווטמינים מקבוצת B, ובחומצות שומן . נלחם במחלות.`,
                    imgName: `tehina`
                },
                {
                    name: `אגוזים ושקדים`,
                    description: `בריאים למוח, תורמים לתחושת שובע, נלחמים במחלות, שומרים על העור, מלאים בסידן וזרחן המחזקים את העצמות והשיניים.עשירים בתחושת שובע.
                    האגוזים מלאים חלבונים ושומנים, מלאים ויטמין E השומר עלינו צעירים, עשירים במגנזיום - האחראי על תיפקוד תקין של מערכת העצבים, השרירים והעצמות. עשיר באבץ לחיזוק מערכת החיסון, עשיר באשלגן לשמירה על תאי העצב, מסייעים למניעה או טיפול בעצירות,  ומאזן את רמת הסוכר.`,
                    imgName: `nuts`
                },
                {
                    name: `שמן זית`,
                    description: `מקדם את בריאות הלב, נלחם במחלות, נגיפים ובדלקות, שומר עלינו צעירים, מרפא דלקות, משפר את בריאות המוח.`,
                    imgName: `olive-oil`
                },
                {
                    name: `זיתים`,
                    description: `מסייעים לתהליך העיכול, שומרים על הלב,  מונעים דלדול עצם, מפחיתים דלקות וכאבים, נלחמים באלרגיות ,משפרים את זרימת הדם. נלחמים בזיהומים מחזקים את העיניים. ונלחמים במחלות.`,
                    imgName: `olives`
                },
                {
                    name: `חמאת בוטנים`,
                    description: `נלחם במחלות, מונע בריחת סידן, עשיר באשלגן החשוב לשרירים לחילוף החומרים,  ולמערכת העצבים,  עשירה בסיבים תזונתיים המשפרים את תפקוד מערכת העיכול. יוצרים תחושת שובע, 
                    מקור צמחי מעולה לחלבונים, הבונים את השרירים וההורמונים בגוף.נלחם ביהומים ובמחלות.`,
                    imgName: `peanut-butter`
                }
            ]
        },
        {
            cardTypeName: `חלבונים`,
            backgroundColor: `white`,
            foods: [
                {
                    name: `גבינה`,
                    description: `עשירה בחלבונים הבונים שרירים, ועשירה בסידן המחזק עצמות ושיניים.`,
                    imgName: `cheese`
                },
                {
                    name: `חזה עוף (מומלץ הודו)`,
                    description: `עשיר בחלבונים הבונים שרירים, ו- B12 לתפקוד גוף תקין. כמו כן, מכיל וויטמינים נוספים מקבוצת B, ברזל, אבץ, מגנזיום וזרחן.`,
                    imgName: `chicken`
                },
                {
                    name: `יוגורט`,
                    description: `מכילים חיידקים טובים המסייעים לגוף, מעבר לחלבון, ביוגורט יש חומרים מזינים נוספים כמו סידן, ויטמין B12, ויטמין B2,אשלגן ומגנזיום. עשיר בויטמין D וסידן אשר מחזקים את העצמות. מסייעים בעיכול, מעניק תחושת שובע.`,
                    imgName: `yogurt`
                },
                {
                    name: `טונה`,
                    description: `מסייע להילחם בדלקות, נלחם במחלות, מגביר תפקוד מוח, שומר על כליות בריאות, שומר ע ל בריאות העיינים,  עשיר מאד בחלבון,  משפר את בריאות הלב ומחזק את המערכת החיסונית, ומעלה את האנרגייה בגופינו.`,
                    imgName: `tuna`
                },
                {
                    name: `ביצה`,
                    description: `ביצה אחת טעונה ברוב החומרים המזינים הנחוצים לגופנו.
                    מכילה חלבון הכי איכותי בטבע.
                    תורמת לבריאות העיניים, מקדמת בריאות הלב, משפרת תפקוד עצבי, התפתחות נוירולוגית, מטבוליזם, ושליטה על השרירים.
                    נלחמת במחלות,
                    נחוץ להתפתחות נאותה של המוח וגם לתפקוד כבד אופטימלי.`,
                    imgName: `egg`
                },
                {
                    name: `סויה-אדממה`,
                    description: `עשירה בחלבון המחזק את העצמות, בונה שרירים, נלחמת במחלות, שיפור בתפקוד מערכת העיכול, משפרת את זרימת ואיכות הדם, שומרת על הלב, ומקל על הפרעות שינה (מגנזיום)`,
                    imgName: `soy`
                }
            ]
        },
        {
            cardTypeName: `פחמימות`,
            backgroundColor: `orange`,
            foods: [
                {
                    name: `לחם חיטה`,
                    description: `עשיר בסיבים תזונתיים התורמים לעיכול ותחושת שובע,  נלחמת במחלות ודלקות, משפרת מצב רוח ויכולת מנטאלית. משפרת ריכוז ועירנות.`,
                    imgName: `bread`
                },
                {
                    name: `פריכית כוסמת`,
                    description: `עשירה בסיבים תזונתיים, מגנזיום, אשלגן, אבץ, ברזל. אינה מכילה חומרים משמרים וגלוטן.`,
                    imgName: `crispy`
                },
                {
                    name: `תירס`,
                    description: `עשיר בסיבים תזונתיים לשידרוג מערכת העיכול, נלחם במחלות, הכרחי לשמירה על בריאות העצבים והתפקודים ההכרתיים. עשיר במינרלים, עשיר בברזל המונע אנמיה, התירס הצהוב הוא מקור עשיר לבטא-קרוטן, התורם להיווצרות ויטמין A בגופנו וחיוני לבריאות הראייה והעור שלנו.`,
                    imgName: `corn`
                },
                {
                    name: `אורז (מומלץ אורז מלא)`,
                    description: `אורז לבן עשיר בפחמימות.
                    האורז דל נתרן (החלק הרע שבמלח) ונטול גלוטן (טוב לחולי צליאק ולאנשים הרגישים לגלוטן). הוא מקור טוב למינרלים דוגמת ברזל ואבץ ולוויטמינים מקבוצה B, לרבות חומצה פולית החשובה במיוחד לנשים בשנות הפוריות. אגב, במקרים רבים האורז הלבן מועשר בוויטמינים מקבוצת B.
                    
                    אורז מלא עשיר בחלבונים, תיאמין, סידן, מגנזיום, סיבים תזונתיים ואשלגן. עשיר בסלניום הנלחם במחלות.
                    
                    כוס אחת של אורז מלא מספקת 80 אחוזים מצריכת המגזניום היומית שלנו. המגזניום מסייע לגופנו בתהליך הסינתזה של השומן, ותורם למערכת העצבים ולמערכת הרבייה של גופנו.
                    מסייעים למערכת העיכול.
                    עשיר בסיבים תזונתיים.
                    עדשיר בנוגדי חימצון השומר עלינו צעירים.`,
                    imgName: `rice`
                },
                {
                    name: `פסטה (מומלץ מקמח מלא)`,
                    description: `עשירים בפחמימות שמסייעות רבות לילדים בדרכים שונות, למשל בשיפור מצב הרוח, בשמירה על משקל גוף תקין, בתרומה לבריאות הלב ובהגנה על יכולות הזיכרון. עשיר גם בברזל.`,
                    imgName: `pasta`
                },
                {
                    name: `דגנים מלאים`,
                    description: `מקור טוב לפחמימות מורכבות, סיבים תזונתיים, חלבון, חומצות שומן חיוניות, מינרלים וויטמיני B.`,
                    imgName: `wheat`
                }
            ]
        },
        {
            cardTypeName: `מים`,
            backgroundColor: `blue`,
            foods: [
                {
                    name: `מים`,
                    description: `הגוף שלנו מורכב מכ-60% מים, יש צורך במים לשמירה על טמפרטורת הגוף, הובלת חומרים מזינים, הבטחת עיכול תקין, יצירת דמעות ורוק, מחזור הדם וכמעט כל הפעולות השונות בגוף דורשות מים.`,
                    imgName: `water`
                },
                {
                    name: `מים עם נענע`,
                    description: `הנענע עשירה בסיבים תזונתיים, מאטה הזדקנות ומחזקת את מערכת העיכול.`,
                    imgName: `mint-water`
                },
                {
                    name: `מים עם לימון`,
                    description: `נלחם במחלות, עשיר בויטמין C , מקור לאשלגן ולסידן לחיזוק העצמות, נלחם בזיהומים.`,
                    imgName: `lemon-water`
                }
            ]
        },
        {
            cardTypeName: `ממתקים וחטיפים`,
            backgroundColor: `pink`,
            foods: [{
                name: `ממתקים וחטיפים`,
                description: `מעלים את מצב הרוח עקב 
                הסוכרים והמלחים הרבים נמצאים בהם, כמו גם חומרים נוספים המזיקים לגוף.  מומלץ להימנע מאכילה מרובה שלהם.
                מסוג המאכלים שמומלץ לאכול אותם פעם ב… ולא הרבה.`,
                imgName: `candy`
            }]
        }
    ]
};

export default InstructionsData;